import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form } from "react-bootstrap";
// import SelectDropDown from '../selectdropdown/SelectDropDown'
import SelectDropDown from "../../selectdropdown/SelectDropDown"
import { components } from 'react-select'
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import moment from "moment";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import MultiSelect from "react-multi-select-component";
// import CardLessDataTableWithSearch from '../datatables/CardLessDataTableWithSearch';
import CardLessDataTableWithSearch from "../../datatables/CardLessDataTableWithSearch"
import MaterialDetailsModal from './MaterialDetailsModal';
import "./_materialCreation.scss";


const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

class MaterialReportHome extends Component {
    constructor(props) {
        super(props);
        this.state = {

            branch: "",
            branchSearch: "0",
            branchSearchval: "",
            branchError: "",

            materialType: "",
            materialTypeSearch: "0",
            materialTypeSearchval: "",
            materialTypeError: "",
            materialTypeDetails: [],


            exam: "",
            examError: "",
            getExamArr: [],
            examSelectedvalue: [],

            class: "",
            classError: "",
            getClassArr: [],
            classSelectedvalue: [],

            section: "",
            sectionError: "",
            getSectionArr: [],
            sectionSelectedvalue: [],


            loader: 0,
            blockType: "1",
            dashboard: false,
            materialDetailsModal: false,
            rowData: [],
            totalStudentsData: [],
            selctedType: ""
        };
    }


    dropDownGetValues(fieldname, value) {
        let getArray = [];

        if (fieldname == "branchSearch") {
            this.props.globals.globalBranches.map((item) => {
                const newObj = {
                    value: item.id,
                    label: item.branch_name
                }
                getArray.push(newObj);
            });

        }

        if (fieldname == "materialTypeSearch") {
            this.state.materialTypeDetails.map((item1) => {
                const newObj = {
                    value: item1.id,
                    label: item1.material_type
                }
                getArray.push(newObj);
            })
        }

        return getArray;
    }

    selecthandleInputChange = (ename, evalue, e) => {

        console.log("nnnnn", e, ename);

        const name = ename;
        const value = evalue;

        let getExamArr = [];
        let getClassArr = [];
        let getSectionArr = [];

        //branch
        if (name == "branchSearch") {
            if (value != "0") {
                let branchSearchData = this.props.globals.globalBranches.find((a) => a.id == value);
                this.setState({
                    branchSearchval: {
                        value: branchSearchData.id,
                        label: branchSearchData.branch_name
                    },
                })
                let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();

                uniqueExams.map((val) => {
                    let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualExamData.id,
                        label: individualExamData.exam
                    }
                    getExamArr.push(newObj);
                });

                //Class selection

                let selectedExamsValues = getExamArr.map((item) => item.value);

                let uniqueClasses = [];

                if (selectedExamsValues.length > 0) {

                    selectedExamsValues.map((val) => {
                        let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
                        uniqueClasses.push(...individualClassValues)
                    });
                }

                if (uniqueClasses.length > 0) {
                    [...new Set(uniqueClasses)].map((val) => {
                        let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualClassData.id,
                            label: individualClassData.class
                        }
                        getClassArr.push(newObj);
                    });

                    let selectedClasses = getClassArr.map((item) => item.value);


                    //section selection

                    let uniqueSections = [];

                    if (selectedClasses.length > 0) {
                        selectedExamsValues.map((val) => {
                            selectedClasses.map((val1) => {
                                let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                                console.log("individualsectionValues", individualsectionValues);
                                if (individualsectionValues.length > 0) {
                                    uniqueSections.push(...individualsectionValues)
                                }
                            })
                        });
                    }

                    if (uniqueSections.length > 0) {
                        [...new Set(uniqueSections)].map((val) => {
                            let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                            const newObj = {
                                value: individualSectionData.id,
                                label: individualSectionData.section_name
                            }
                            getSectionArr.push(newObj);
                        });
                    }
                }

                this.setState({
                    branchSearchval: {
                        value: branchSearchData.id,
                        label: branchSearchData.branch_name
                    },
                    branch: branchSearchData.branch_name,
                    branchSearch: branchSearchData.id,
                    getExamArr: getExamArr,
                    examSelectedvalue: getExamArr,
                    getClassArr: getClassArr,
                    classSelectedvalue: getClassArr,
                    getSectionArr: getSectionArr,
                    sectionSelectedvalue: getSectionArr,
                    branchError: "",
                    examError: "",
                    classError: "",
                    sectionError: "",
                    totalStudentsData: [],
                    materialType: "",
                    materialTypeSearch: "0",
                    materialTypeSearchval: "",
                    materialTypeError: "",
                    blockType: "1",
                    dashboard: false

                });
                this.getMaterialTypes();
            } else {
                this.setState({
                    branchSearch: "0",
                    branchSearchval: "",
                    branchError: "",
                    getClasses: [],
                    getSections: [],
                    getExams: [],
                    totalStudentsData: [],
                    materialType: "",
                    materialTypeSearch: "0",
                    materialTypeSearchval: "",
                    materialTypeError: "",
                    blockType: "1",
                    dashboard: false

                });
            }
        }

        if (name == "materialTypeSearch") {
            if (value != "0") {
                let materialTypeData = this.state.materialTypeDetails.find((a) => a.id == value);

                console.log("materialTypeData", materialTypeData)

                this.setState({
                    materialTypeSearchval: {
                        value: materialTypeData.id,
                        label: materialTypeData.material_type
                    },
                    materialType: materialTypeData.material_type,
                    materialTypeSearch: materialTypeData.id,
                    materialTypeError: "",
                    totalStudentsData: [],
                    blockType: "1",
                    dashboard: false

                })
            } else {
                this.setState({
                    materialType: "",
                    materialTypeSearch: "0",
                    materialTypeSearchval: "",
                    materialTypeError: "",
                    totalStudentsData: [],
                    blockType: "1",
                    dashboard: false

                });
            }
        }

        this.setState({ [name]: value });

    }

    handleMultipleSelectInputChange = (e, name) => {

        console.log("multipleChange", e, name);


        if (name == "class") {

            let classSelectedvalue = [];
            let getSectionArr = [];

            if (e.length > 0) {
                for (let i = 0; i < e.length; i++) {
                    const classval = e[i];
                    const newObj = {
                        label: classval.label,
                        value: classval.value,
                    }
                    classSelectedvalue.push(newObj);
                }

                let selectedExamsValues = this.state.examSelectedvalue.map((item) => item.value);
                let selectedClasses = classSelectedvalue.map((item) => item.value);
                let uniqueSections = [];

                if (selectedClasses.length > 0) {
                    selectedExamsValues.map((val) => {
                        selectedClasses.map((val1) => {
                            let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                            if (individualsectionValues.length > 0) {
                                uniqueSections.push(...individualsectionValues)
                            }
                        })
                    });
                }

                if (uniqueSections.length > 0) {
                    [...new Set(uniqueSections)].map((val) => {
                        let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualSectionData.id,
                            label: individualSectionData.section_name
                        }
                        getSectionArr.push(newObj);
                    });
                }


                this.setState({
                    classSelectedvalue: classSelectedvalue,
                    classError: "",
                    sectionError: "",
                    getSectionArr: getSectionArr,
                    sectionSelectedvalue: getSectionArr,
                    dashboard: false,
                    materialType: "",
                    materialTypeSearch: "0",
                    materialTypeSearchval: "",
                    materialTypeError: "",
                    totalStudentsData: [],
                    blockType: "1",

                });
            } else {
                this.setState({
                    classSelectedvalue: classSelectedvalue,
                    classError: "",
                    getSectionArr: [],
                    sectionSelectedvalue: [],
                    dashboard: false,
                    materialType: "",
                    materialTypeSearch: "0",
                    materialTypeSearchval: "",
                    materialTypeError: "",
                    totalStudentsData: [],
                    blockType: "1",


                });
            }
        }

        if (name == "exam") {
            let examSelectedvalue = [];

            if (e.length > 0) {

                for (let i = 0; i < e.length; i++) {
                    const examval = e[i];
                    const newObj = {
                        label: examval.label,
                        value: examval.value,
                    }
                    examSelectedvalue.push(newObj);
                }


                let selectedExamsValues = examSelectedvalue.map((item) => item.value);

                let uniqueClasses = [];
                let getClassArr = [];
                let getSectionArr = [];


                if (selectedExamsValues.length > 0) {

                    selectedExamsValues.map((val) => {
                        let individualClassValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val)).map((item1) => item1.class_id))].sort();
                        console.log("individualClassValues", individualClassValues);
                        uniqueClasses.push(...individualClassValues)
                    });
                }



                if (uniqueClasses.length > 0) {
                    [...new Set(uniqueClasses)].map((val) => {

                        console.log("uniqueClasses", val);

                        let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                        const newObj = {
                            value: individualClassData.id,
                            label: individualClassData.class
                        }
                        getClassArr.push(newObj);
                    });

                    let selectedClasses = getClassArr.map((item) => item.value);


                    //section selection

                    let uniqueSections = [];

                    if (selectedClasses.length > 0) {
                        selectedExamsValues.map((val) => {
                            selectedClasses.map((val1) => {
                                let individualsectionValues = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branchSearch && item.exam_id == parseInt(val) && item.class_id == parseInt(val1)).map((item1) => item1.section_id))].sort();
                                if (individualsectionValues.length > 0) {
                                    uniqueSections.push(...individualsectionValues)
                                }
                            })
                        });
                    }

                    if (uniqueSections.length > 0) {
                        [...new Set(uniqueSections)].map((val) => {
                            let individualSectionData = this.props.globals.globalSections.find((item1) => item1.id == val);
                            const newObj = {
                                value: individualSectionData.id,
                                label: individualSectionData.section_name
                            }
                            getSectionArr.push(newObj);
                        });
                    }
                }

                this.setState({
                    examSelectedvalue: examSelectedvalue,
                    examError: "",
                    classError: "",
                    sectionError: "",
                    getClassArr: getClassArr,
                    classSelectedvalue: getClassArr,
                    getSectionArr: getSectionArr,
                    sectionSelectedvalue: getSectionArr,
                    dashboard: false,
                    materialType: "",
                    materialTypeSearch: "0",
                    materialTypeSearchval: "",
                    materialTypeError: "",
                    totalStudentsData: [],
                    blockType: "1",
                });
            } else {
                this.setState({
                    examSelectedvalue: [],
                    getClassArr: [],
                    classSelectedvalue: [],
                    getSectionArr: [],
                    sectionSelectedvalue: [],
                    dashboard: false,
                    materialType: "",
                    materialTypeSearch: "0",
                    materialTypeSearchval: "",
                    materialTypeError: "",
                    totalStudentsData: [],
                    blockType: "1",


                });
            }
        }

        if (name == "section") {

            let sectionSelectedvalue = [];

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const sectionval = e[i];
                    const newObj = {
                        label: sectionval.label,
                        value: sectionval.value,
                    }
                    sectionSelectedvalue.push(newObj);
                }
                this.setState({
                    sectionSelectedvalue: sectionSelectedvalue,
                    sectionError: "",
                    dashboard: false,
                    materialType: "",
                    materialTypeSearch: "0",
                    materialTypeSearchval: "",
                    materialTypeError: "",
                    totalStudentsData: [],
                    blockType: "1",

                });

            }
        }
    }

    getMaterialTypes = async (val) => {
        const result = await this.props.client.query({
            query: gql`
            query($id:Int){
                getMaterialTypes(id:$id){
                    id
                    material_type
                  }
               }
            `,
            variables: {
                id: 0,
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getMaterialTypes.length > 0) {
            let data = result.data.getMaterialTypes;
            // console.log("data", data)
            this.setState({ materialTypeDetails: data })
        } else {
            this.setState({ materialTypeDetails: [] })
        }
    }

    handleSubmit = async (e) => {

        if (this.state.branch == "") {
            this.setState({ branchError: "Please Select Branch" });
            return ""
        }


        if (!this.state.examSelectedvalue.length) {
            this.setState({ examError: "Please Select Exam" });
            return ""
        }

        if (!this.state.classSelectedvalue.length) {
            this.setState({ classError: "Please Select Class" });
            return ""
        }


        if (!this.state.sectionSelectedvalue.length) {
            this.setState({ sectionError: "Please Select Section" });
            return ""
        }

        if (this.state.materialType == "") {
            this.setState({ materialTypeError: "Please Select Material Type" });
            return ""
        }

        this.setState({ loader: 1 })




        const result = await this.props.client.query({
            query: gql`
              query($institute_id:Int,$branch_id:Int,$exam_id:String,$class_id:String,$section_id:String,$material_type_id:Int){
                getMaterialReport(institute_id:$institute_id,branch_id:$branch_id,exam_id:$exam_id,class_id:$class_id,section_id:$section_id,material_type_id:$material_type_id){

                    total_students{
                        student_id
                        student_name
                        roll_no
                        ecs
                        
                        materials{
                          material_id
                          material_name
                        }
                        materials_delivered{
                          material_id
                          material_name
                          delivOrRecvDate
                        }
                        materials_received{
                          material_id
                          material_name
                          delivOrRecvDate
                        }
                        materials_pending{
                          material_id
                          material_name
                          delivOrRecvDate
                        }
                        materials_not_received{
                          material_id
                          material_name
                          delivOrRecvDate
                        }
                      }
                  
                      fully_deliv_students{
                        student_id
                        student_name
                        roll_no
                        ecs
                        
                        materials{
                          material_id
                          material_name
                        }
                        materials_delivered{
                          material_id
                          material_name
                          delivOrRecvDate
                        }
                        materials_received{
                          material_id
                          material_name
                          delivOrRecvDate
                        }
                        materials_pending{
                          material_id
                          material_name
                          delivOrRecvDate
                        }
                        materials_not_received{
                          material_id
                          material_name
                          delivOrRecvDate
                        }
                      }

                      partly_deliv_students{
                        student_id
                        student_name
                        roll_no
                        ecs
                        
                        materials{
                          material_id
                          material_name
                        }
                        materials_delivered{
                          material_id
                          material_name
                          delivOrRecvDate
                        }
                        materials_received{
                          material_id
                          material_name
                          delivOrRecvDate
                        }
                        materials_pending{
                          material_id
                          material_name
                          delivOrRecvDate
                        }
                        materials_not_received{
                          material_id
                          material_name
                          delivOrRecvDate
                        }
                      }

                      not_deliv_students{
                        student_id
                        student_name
                        roll_no
                        ecs
                        
                        materials{
                          material_id
                          material_name
                        }
                        materials_delivered{
                          material_id
                          material_name
                          delivOrRecvDate
                        }
                        materials_received{
                          material_id
                          material_name
                          delivOrRecvDate
                        }
                        materials_pending{
                          material_id
                          material_name
                          delivOrRecvDate
                        }
                        materials_not_received{
                          material_id
                          material_name
                          delivOrRecvDate
                        }
                      }

                      

                      
                    }
                }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(this.state.branchSearch),
                exam_id: this.state.examSelectedvalue.map((item) => item.value).toString(),
                class_id: this.state.classSelectedvalue.map((item) => item.value).toString(),
                section_id: this.state.sectionSelectedvalue.map((item) => item.value).toString(),
                material_type_id: parseInt(this.state.materialTypeSearch),
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getMaterialReport.length > 0) {

            console.log("dataaaaaaaaaaaaa", result.data.getMaterialReport);
            let data = result.data.getMaterialReport

            this.setState({ totalStudentsData: data, loader: 0, dashboard: true })

        } else {
            this.setState({ totalStudentsData: [], loader: 0, dashboard: true })
        }
    }


    articlecolumns = [
        {
            dataField: "student_name",
            text: "Student Name",
            sort: true,
        },

        {
            dataField: "roll_no",
            text: "Roll No.",
            sort: true,
        },
        {
            dataField: "ecs",
            text: "Exam/Class/Section",
            sort: true,
        },
        {
            dataField: "materials",
            text: "Material Quantity",
            formatter: this.materialData.bind(this),
            sort: true,
        },
        {
            dataField: "materials_delivered",
            text: "Material Delivered",
            formatter: this.materialData.bind(this),
            sort: true,
        },
        {
            dataField: "materials_pending",
            text: "Material Pending",
            formatter: this.materialData.bind(this),
            sort: true,
        },
        {
            dataField: "materials_received",
            text: "Material Received",
            formatter: this.materialData.bind(this),
            sort: true,
        },
        {
            dataField: "materials_not_received",
            text: "Material Not Received",
            formatter: this.materialData.bind(this),
            sort: true,
        },

    ];


    materialData(val, row, a, b, c) {
        return (<>
            <div>
                {
                    val.length > 0 ? (
                        <a href="#" onClick={() => { this.setState({ materialDetailsModal: true, rowData: val, selctedType: "" }) }}>
                            {val.length}
                        </a>
                    ) : (val.length)
                }

            </div>
        </>)
    }



    tableData(data) {
        let returnData = [];
        data.map((mapData) => {
            const newObj = {
                student_name: mapData.student_name,
                roll_no: mapData.roll_no,
                ecs: mapData.ecs,
                materials: mapData.materials,
                materials_delivered: mapData.materials_delivered,
                materials_pending: mapData.materials_pending,
                materials_received: mapData.materials_received,
                materials_not_received: mapData.materials_not_received,
            }
            returnData.push(newObj);
        });
        return returnData;
    }



    render() {

        console.log("mahesh", this.state)

        let examselectall = true;
        let examlabelledBy = "Select";
        let examdisableSearch = false;

        let classselectall = true;
        let classlabelledBy = "Select";
        let classdisableSearch = false;

        let sectionselectall = true;
        let sectionlabelledBy = "Select";
        let sectiondisableSearch = false;

        if (this.props.globals.classes.length > 0) {
            classselectall = true;
            classdisableSearch = false;
        }
        else {
            classdisableSearch = true;
            classselectall = false;
            classlabelledBy = "class"
        }


        if (this.props.globals.exams.length > 0) {
            examselectall = true;
            examdisableSearch = false;
        }
        else {
            examdisableSearch = true;
            examselectall = false;
            examlabelledBy = "exam"
        }

        if (this.props.globals.globalSections.length > 0) {
            sectionselectall = true;
            sectiondisableSearch = false;
        }
        else {
            sectiondisableSearch = true;
            sectionselectall = false;
            sectionlabelledBy = "section"
        }

        let materialData = [];


        if (this.state.totalStudentsData.length > 0) {

            materialData = this.state.blockType == "1" ? this.state.totalStudentsData[0].total_students : this.state.blockType == "2" ? this.state.totalStudentsData[0].fully_deliv_students : this.state.blockType == "3" ? this.state.totalStudentsData[0].partly_deliv_students : this.state.totalStudentsData[0].not_deliv_students

        }


        return (
            <section className="material_report">
                <Container>
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12}>
                            <div className="breadcrumb_section border-bottom border-theme pb-1 my-4 d-flex align-items-center justify-content-between">
                                <h2 className="title h5 mb-0">Material Report</h2>
                            </div>
                        </Col>
                        <Col xl={12} lg={12} md={12} sm={12} className="studentTable">
                            <Card className="border-0 shadow-sm mb-4 ">
                                <Card.Header>
                                    <Row>
                                        <Col lg={2} md={12} sm={12}>
                                            <h6>Branch </h6>
                                            <SelectDropDown
                                                stateData={this.state.branchSearchval}
                                                handleChange={this.selecthandleInputChange}
                                                name="branchSearch"
                                                options={this.dropDownGetValues("branchSearch")}
                                                placeholderName={'Branch'}
                                                dropdownIndicator={{ DropdownIndicator }}
                                            />
                                            <span className="text-danger" style={{fontSize:"12px"}}>{this.state.branchError}</span>
                                        </Col>
                                        <Col lg={2} md={12} sm={12}>
                                            <h6>Exam </h6>
                                            <MultiSelect
                                                overrideStrings={{
                                                    "allItemsAreSelected": "All Exams are selected.",
                                                    "selectSomeItems": examlabelledBy
                                                }
                                                }
                                                disableSearch={examdisableSearch}
                                                hasSelectAll={examselectall}
                                                options={this.state.getExamArr}
                                                value={this.state.examSelectedvalue}
                                                onChange={(e) => this.handleMultipleSelectInputChange(e, "exam")}
                                                labelledBy={"exam"}
                                            />
                                            <span className="text-danger" style={{fontSize:"12px"}}>{this.state.examError}</span>
                                        </Col>

                                        <Col lg={2} md={12} sm={12}>
                                            <h6>Class </h6>
                                            <MultiSelect
                                                overrideStrings={{
                                                    "allItemsAreSelected": "All Class are selected.",
                                                    "selectSomeItems": classlabelledBy
                                                }
                                                }
                                                disableSearch={classdisableSearch}
                                                hasSelectAll={classselectall}
                                                options={this.state.getClassArr}
                                                value={this.state.classSelectedvalue}
                                                onChange={(e) => this.handleMultipleSelectInputChange(e, "class")}
                                                labelledBy={"class"}
                                            />
                                            <span
                                                className="text-danger" style={{fontSize:"12px"}}>{this.state.classError}</span>
                                        </Col>
                                        <Col lg={2} md={12} sm={12}>
                                            <h6>Section</h6>
                                            <MultiSelect
                                                overrideStrings={{
                                                    "allItemsAreSelected": "All Sections are selected.",
                                                    "selectSomeItems": sectionlabelledBy
                                                }
                                                }
                                                disableSearch={sectiondisableSearch}
                                                hasSelectAll={sectionselectall}
                                                options={this.state.getSectionArr}
                                                value={this.state.sectionSelectedvalue}
                                                onChange={(e) => this.handleMultipleSelectInputChange(e, "section")}
                                                labelledBy={"section"}
                                            />
                                            <span className="text-danger" style={{fontSize:"12px"}}>{this.state.sectionError}</span>
                                        </Col>

                                        <Col lg={2} md={12} sm={12}>
                                            <h6>Material Type</h6>
                                            <SelectDropDown
                                                stateData={this.state.materialTypeSearchval}
                                                handleChange={this.selecthandleInputChange}
                                                name="materialTypeSearch"
                                                options={this.dropDownGetValues("materialTypeSearch")}
                                                placeholderName={'Material Type'}
                                                dropdownIndicator={{ DropdownIndicator }}
                                            />
                                            <span className="text-danger" style={{fontSize:"12px"}}>{this.state.materialTypeError}</span>
                                        </Col>

                                        <Col lg={2} md={12} sm={12}>
                                            <Button className="text-uppercase mt-4 ml-4" style={{ backgroundColor: "#213046", color: "#ffffff" }} onClick={this.handleSubmit}>Get Report</Button>
                                        </Col>
                                    </Row>
                                </Card.Header>

                                {
                                    this.state.dashboard == true && this.state.totalStudentsData.length > 0 ?
                                        (
                                            <Card.Body>

                                                <Container fluid className='materialreport'>
                                                    <Row>
                                                        <Col sm={3} className='mt-3 mb-3'>
                                                            <Card className={this.state.blockType == "1" ? "active block_view" : " block_view"} onClick={() => this.setState({ blockType: "1" })}>
                                                                <Card.Body>
                                                                    <h5 className="text-center"><span className='title_alignment'>Total Students</span></h5>
                                                                    <h5 className="text-center"><span className='title_alignment'>{this.state.totalStudentsData[0].total_students.length}</span></h5>
                                                                </Card.Body>
                                                            </Card>
                                                        </Col>
                                                        <Col sm={3} className='mt-3 mb-3'>
                                                            <Card className={this.state.blockType == "2" ? "active block_view" : " block_view"} onClick={() => this.setState({ blockType: "2" })}>
                                                                <Card.Body>
                                                                    <h5 className="text-center"><span className='title_alignment'>Fully Delivered</span></h5>
                                                                    <h5 className="text-center"><span className='title_alignment'>{this.state.totalStudentsData[0].fully_deliv_students.length}</span></h5>

                                                                </Card.Body>
                                                            </Card>
                                                        </Col>
                                                        <Col sm={3} className='mt-3 mb-3'>
                                                            <Card className={this.state.blockType == "3" ? "active block_view" : " block_view"} onClick={() => this.setState({ blockType: "3" })}>
                                                                <Card.Body>
                                                                    <h5 className="text-center"><span className='title_alignment'>Partially Delivered</span></h5>
                                                                    <h5 className="text-center"><span className='title_alignment'>{this.state.totalStudentsData[0].partly_deliv_students.length}</span></h5>

                                                                </Card.Body>
                                                            </Card>
                                                        </Col>
                                                        <Col sm={3} className='mt-3 mb-3'>
                                                            <Card className={this.state.blockType == "4" ? "active block_view" : " block_view"} onClick={() => this.setState({ blockType: "4" })}>
                                                                <Card.Body>
                                                                    <h5 className="text-center"><span className='title_alignment'>Not Delivered</span></h5>
                                                                    <h5 className="text-center"><span className='title_alignment'>{this.state.totalStudentsData[0].not_deliv_students.length}</span></h5>
                                                                </Card.Body>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                    <Col xl={12} lg={12} md={12} sm={12}>
                                                        {
                                                            materialData.length > 0 ?
                                                                (

                                                                    <CardLessDataTableWithSearch
                                                                        parentData={this.tableData(materialData)}
                                                                        particlecolumns={this.articlecolumns}
                                                                        name="attendance"
                                                                    />

                                                                ) : (
                                                                    <Col ls={12} md={12} sm={12}>
                                                                        <h4 className='mt-3 text-center'><span className="text-danger"> * </span> No data available</h4>
                                                                    </Col>
                                                                )
                                                        }
                                                        </Col>
                                                    </Row>
                                                </Container>

                                            </Card.Body>
                                        ) : (
                                            this.state.dashboard == true && this.state.totalStudentsData.length == 0 ? (
                                                <Row>
                                                    <Col ls={12} md={12} sm={12}>
                                                        <h4 className='mt-3 text-center'><span className="text-danger"> * </span> No data available</h4>
                                                    </Col>
                                                </Row>
                                            ) : ("")
                                        )
                                }
                            </Card>
                            {
                                this.state.loader == 1 ? (
                                    <Row className="my-2">
                                        <Col>
                                            <div className="spinner-border text-primary text-center loading-img-center"></div>
                                        </Col>
                                    </Row>
                                ) : ("")
                            }

                        </Col>
                    </Row>
                    <MaterialDetailsModal
                        stateData={this.state}
                        show={this.state.materialDetailsModal}
                        onHide={() => this.setState({ materialDetailsModal: false })}
                    />
                </Container>
            </section>)
    }
}

export default withRouter(withApollo(compose(

)(MaterialReportHome))
);
